var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExitStrategyBuyBackNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 137,
    viewBox: "0 0 236 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4263_8929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.67 17.72L171 52.22L145.47 118.01L116 68.22L75.38 38.8699L0.75 89.5599V137H234.67V17.72Z",
    fill: "url(#paint0_linear_4263_8929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 89.5599L75.38 38.8699L115 67.22L145.47 118.01L171 52.22L234.5 19.72",
    stroke: "#FF9900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 66.72H35",
    stroke: "#F24400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.4414,
    cy: 66.6499,
    r: 0.75,
    fill: "#F24400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 47.72H63",
    stroke: "#F24400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.209,
    cy: 47.8599,
    r: 0.75,
    fill: "#F24400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 28.72H212",
    stroke: "#F24400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.72H235",
    stroke: "#F24400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 33.0601C218.209 33.0601 220 31.2692 220 29.0601C220 26.8509 218.209 25.0601 216 25.0601C213.791 25.0601 212 26.8509 212 29.0601C212 31.2692 213.791 33.0601 216 33.0601Z",
    fill: "#F24400",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0605 70.95C37.2697 70.95 39.0605 69.1591 39.0605 66.95C39.0605 64.7408 37.2697 62.95 35.0605 62.95C32.8514 62.95 31.0605 64.7408 31.0605 66.95C31.0605 69.1591 32.8514 70.95 35.0605 70.95Z",
    fill: "#F24400",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8594 52.1799C65.0685 52.1799 66.8594 50.3891 66.8594 48.1799C66.8594 45.9708 65.0685 44.1799 62.8594 44.1799C60.6502 44.1799 58.8594 45.9708 58.8594 48.1799C58.8594 50.3891 60.6502 52.1799 62.8594 52.1799Z",
    fill: "#F24400",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4263_8929",
    x1: 117.71,
    y1: 47.5599,
    x2: 117.71,
    y2: 134.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4263_8929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 235.42,
    height: 136.28,
    fill: "white",
    transform: "translate(0 0.719971)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitStrategyBuyBackNone);
export default __webpack_public_path__ + "static/media/exit-strategy-buy-back-none.df3686bcefcfcadedcf735c4b76a3f19.svg";
export { ForwardRef as ReactComponent };